import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/Form/ComboboxInput";
import { useForm } from "react-hook-form";
import DeliveryChargeTable from "../Merchant/DeliveryChargeTable";

const DeliveryChargeList = () => {
  const { templateID } = useParams()
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors
  } = useForm<any>();
  const localServiceBranch = watch("local_branch")
  const localServiceType = watch("local_service")

  return (
    <>
      <Card title={`Rate List`}>
        <div className='w-full grid grid-cols-2 gap-x-6'>
          <ComboboxInput
            url={APIS.BRANCH}
            props={{}}
            queryKey={"local-branch"}
            register={register("local_branch")}
            errors={errors?.local_branch}
            name={"local_branch"}
            label={"Service Branch"}
            setValue={setValue}
            placeholder={"Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{}}
            queryKey={"local-service"}
            register={register("local_service")}
            errors={errors?.local_service}
            name={"local_service"}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Card >
      <Card title={`Rate Format`}>
        {localServiceBranch && localServiceType ?
          <DeliveryChargeTable localServiceBranch={localServiceBranch} localServiceType={localServiceType} merchantId={null} delivery_charge_template={templateID} />
          : <> <p>Please select Service Branch And Service type</p>
          </>
        }
      </Card>
    </>

  );
};



export default DeliveryChargeList
